/* Scoped interaction polish for the brush. Core cart and variant handling stay native. */
(() => {
  function init() {
    document.querySelectorAll('.hcb-page').forEach(root => {
      if (root.dataset.responsiveReady) return;
      root.dataset.responsiveReady = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      root.querySelectorAll('[data-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-track]');
        const controls = carousel.querySelector('.hc-carousel-controls, .hcb-ugc-controls');
        const counter = carousel.querySelector('[data-position]');
        if (!track || !controls) return;
        const update = () => {
          controls.hidden = track.scrollWidth <= track.clientWidth + 2;
          if (!counter || controls.hidden) return;
          const box = track.getBoundingClientRect();
          const visible = [...track.children].map((child, i) => ({i, box:child.getBoundingClientRect()}))
            .filter(item => item.box.left >= box.left - 4 && item.box.right <= box.right + 4);
          if (!visible.length) return;
          const first = visible[0].i + 1, last = visible[visible.length - 1].i + 1;
          counter.textContent = `${first === last ? first : `${first}–${last}`} / ${track.children.length}`;
        };
        track.addEventListener('scroll', update, {passive:true});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const step = track.children[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
          const left = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth : track.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
          track.scrollTo({left, behavior:reduced.matches ? 'auto' : 'smooth'});
        });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        else window.addEventListener('resize', update, {passive:true});
        update();
      });

    });
  }
  // Run after the theme's base handlers so responsive counters remain authoritative.
  const scheduleInit = () => requestAnimationFrame(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scheduleInit,{once:true});
  else scheduleInit();
  document.addEventListener('shopify:section:load',scheduleInit);
})();
